import { Controller } from "stimulus"

// Table of contents: sync TOC pane with FR/EN tab, highlight active section (scroll spy).
// Use data-controller="table-of-contents" with data-toc-pane, data-toc-content-pane, optional data-toc-tablist.
export default class extends Controller {
  static targets = []

  connect() {
    this.setupTabSync()
    this.setupScrollSpy()
  }

  disconnect() {
    if (this._observer) {
      this._observer.disconnect()
    }
    if (this._tablist) {
      this._tablist.removeEventListener("shown.bs.tab", this._onTabShown)
    }
  }

  setupTabSync() {
    this._tablist = this.element.querySelector("[data-toc-tablist]") || this.element.querySelector("[data-article-toc-tablist]")
    if (!this._tablist) return
    this._onTabShown = this.onTabShown.bind(this)
    this._tablist.addEventListener("shown.bs.tab", this._onTabShown)
    const activeTab = this._tablist.querySelector(".nav-link.active")
    if (activeTab) {
      const locale = activeTab.getAttribute("data-locale")
      this.showSommairePane(locale)
    }
  }

  onTabShown(e) {
    const locale = e.target.getAttribute("data-locale")
    if (locale) this.showSommairePane(locale)
    this.observeContentPane(locale)
  }

  showSommairePane(locale) {
    const selector = ".article-toc-pane, .toc-pane, [data-toc-pane], [data-article-toc-pane]"
    this.element.querySelectorAll(selector).forEach((el) => {
      const paneLocale = el.getAttribute("data-toc-pane") || el.getAttribute("data-article-toc-pane")
      el.classList.toggle("d-none", paneLocale !== locale)
    })
  }

  setupScrollSpy() {
    const activeTab = this._tablist && this._tablist.querySelector(".nav-link.active")
    const locale = activeTab ? activeTab.getAttribute("data-locale") : this.detectCurrentLocale()
    this.observeContentPane(locale)
  }

  detectCurrentLocale() {
    const visibleTocPane = this.element.querySelector(".article-toc-pane:not(.d-none)[data-article-toc-pane], .toc-pane:not(.d-none)[data-toc-pane], [data-toc-pane]:not(.d-none)")
    if (visibleTocPane) return visibleTocPane.getAttribute("data-toc-pane") || visibleTocPane.getAttribute("data-article-toc-pane")

    const firstTocPane = this.element.querySelector("[data-toc-pane], [data-article-toc-pane]")
    if (firstTocPane) return firstTocPane.getAttribute("data-toc-pane") || firstTocPane.getAttribute("data-article-toc-pane")

    const visibleContentPane = this.element.querySelector(
      '[data-toc-content-pane]:not(.d-none):not(.fade):not(.tab-pane), [data-toc-content-pane].show.active, [data-article-toc-content-pane]:not(.d-none):not(.fade):not(.tab-pane), [data-article-toc-content-pane].show.active'
    )
    if (visibleContentPane) return visibleContentPane.getAttribute("data-toc-content-pane") || visibleContentPane.getAttribute("data-article-toc-content-pane")

    const firstContentPane = this.element.querySelector("[data-toc-content-pane], [data-article-toc-content-pane]")
    if (firstContentPane) return firstContentPane.getAttribute("data-toc-content-pane") || firstContentPane.getAttribute("data-article-toc-content-pane")

    return "fr"
  }

  observeContentPane(locale) {
    if (this._observer) this._observer.disconnect()
    const pane = this.element.querySelector(`[data-toc-content-pane="${locale}"], [data-article-toc-content-pane="${locale}"]`)
    if (!pane) return
    const content = pane.querySelector(".article-content")
    if (!content) return

    const headings = content.querySelectorAll("h2.anchor[id]")
    if (headings.length === 0) return

    const sommairePane = this.element.querySelector(`#sommaire-${locale}`)
    if (!sommairePane) return

    const links = sommairePane.querySelectorAll(".article-toc-link, .toc-link")

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id
          const link = sommairePane.querySelector(`[data-section-id="${id}"]`)
          if (!link) return
          if (entry.isIntersecting) {
            links.forEach((l) => l.classList.remove("active"))
            link.classList.add("active")
          }
        })
      },
      {
        root: null,
        rootMargin: "-80px 0px -70% 0px",
        threshold: 0
      }
    )

    headings.forEach((h) => this._observer.observe(h))
    const firstLink = links[0]
    if (firstLink) {
      links.forEach((l) => l.classList.remove("active"))
      firstLink.classList.add("active")
    }
  }
}
